import React from "react";
import { PHASES } from "@/lib/format";
import { Check } from "lucide-react";

const PhaseTimeline = ({ currentPhase = 1, onJump = null }) => (
    <ol className="flex items-center gap-0 w-full" data-testid="phase-timeline">
        {PHASES.map((p, idx) => {
            const done = p.id < currentPhase;
            const active = p.id === currentPhase;
            const clickable = Boolean(onJump);
            return (
                <li key={p.id} className="flex-1 min-w-0">
                    <button
                        type="button"
                        disabled={!clickable}
                        onClick={() => clickable && onJump(p.id)}
                        data-testid={`phase-step-${p.id}`}
                        className={`w-full text-left group ${clickable ? "cursor-pointer" : "cursor-default"}`}
                    >
                        <div className="flex items-center">
                            <div
                                className={`shrink-0 w-8 h-8 rounded-full grid place-items-center border text-[12px] font-semibold transition-colors ${
                                    done
                                        ? "bg-emerald-500 border-emerald-500 text-white"
                                        : active
                                        ? "bg-slate-900 border-slate-900 text-white"
                                        : "bg-white border-gray-300 text-gray-500"
                                }`}
                            >
                                {done ? <Check size={14} strokeWidth={3} /> : p.id}
                            </div>
                            {idx < PHASES.length - 1 && (
                                <div
                                    className={`flex-1 h-px mx-2 transition-colors ${
                                        done ? "bg-emerald-400" : "bg-gray-200"
                                    }`}
                                />
                            )}
                        </div>
                        <div className="mt-2 pr-2">
                            <div className="text-[11px] uppercase tracking-[0.18em] text-gray-400">Phase {p.id}</div>
                            <div
                                className={`text-sm font-medium mt-0.5 ${
                                    active ? "text-slate-900" : done ? "text-emerald-700" : "text-gray-500"
                                }`}
                            >
                                {p.short}
                            </div>
                        </div>
                    </button>
                </li>
            );
        })}
    </ol>
);

export default PhaseTimeline;
